// Packages
import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import rightangle from "../../assets/images/rightangle.svg";
import { Redirect } from "react-router-dom";
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import userService from "../../services/user.service";
import "./superAdmin.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SuccessDialog from "../schoolAdminPortal/Popups/SuccessDialog";
import { Field, Form, Formik } from "formik";
import validationSchema from "../../Validation/ValidationSchemas";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import { CircularProgress } from "@material-ui/core";

class WebsiteDetails extends Component {
  constructor(props) {
    super();
    this.state = {
      headingContactUS: "",
      subHeadingContactUs: "",
      ContactUsId: null,
      submitting: false,
      redirectToRow: false,
      msg: "",
      successPopup: false,
      loginRole: getFromLocalStorage("loginRole"),
    };
  }

  componentDidMount() {
    const acticve = document.getElementById("Website");
    if (acticve) acticve.classList.add("active");
    this.setState({ submitting: true });
    this.getContactUs();
  }

  getContactUs() {
    userService.getAllWebsiteContactUs().then((res) => {
      const data = res.data.data.websiteContactUsDetailsResponses[0];
      this.setState({
        headingContactUS: data.heading,
        subHeadingContactUs: data.subHeading,
        ContactUsId: data.id,
        submitting: false,
      });
    });
  }

  updateContactUs = ({ contactHeading, contactSubHeading }) => {
    this.setState({ submitting: true });
    const { ContactUsId } = this.state;
    userService
      .updateWebsiteContactUs(contactHeading, contactSubHeading, ContactUsId)
      .then((res) => {
        this.setState({
          msg: "Data updated successfully",
          successPopup: true,
          submitting: false,
        });
      });
  };

  toggleSuccessDialog = () => {
    this.setState({ successPopup: false });
  };

  render() {
    const {
      redirectToRow,
      headingContactUS,
      subHeadingContactUs,
      submitting,
      msg,
      successPopup,
      loginRole,
    } = this.state;

    if (redirectToRow) return <Redirect to="/website" />;

    return (
      <>
        {loginRole === "SUPER ADMIN" ? (
          <div id="superAdmin-table">
            <SuperAdminDashboard />
            <div className="content-layout">
              <Tabs defaultIndex={0}>
                <div className="row w-100">
                  <div className="col-12 col-md-4 col-lg-3 w-100 fixed-left-container">
                    <TabList className="w-100">
                      <div className="pd-5">
                        <button
                          className="custom-back-button mg-bottom-10 mg-top-10"
                          onClick={() => this.setState({ redirectToRow: true })}
                        >
                          <span className="custom-back-button-icon">
                            <ArrowBackIcon className="backarrow-icon" />
                          </span>
                          <div className="custom-back-button-text d-flex-center w-100">
                            <span className="bold fs-18">Contact Us</span>
                          </div>
                        </button>
                      </div>
                      <Tab style={{ backgroundColor: "white" }}>
                        <div className="landing-dtls">
                          <p>Contact Us</p>
                          <span className="parz">
                            <img src={rightangle} alt="" />
                          </span>
                        </div>
                      </Tab>
                    </TabList>
                  </div>

                  <div className="col-12 col-md-8 col-lg-9 w-100">
                    <TabPanel>
                      <Formik
                        enableReinitialize
                        initialValues={{
                          contactHeading: headingContactUS,
                          contactSubHeading: subHeadingContactUs,
                        }}
                        validationSchema={validationSchema.contactUsDetails}
                        onSubmit={this.updateContactUs}
                      >
                        {(formik) => (
                          <Form>
                            <div className="panel-content conclass-website height-90-vh">
                              <div className="row">
                                <div className="col-lg-8 col-md-8">
                                  <label className="email black fs-18 emailtxtweb">
                                    HEADING
                                  </label>
                                  <Field
                                    type="text"
                                    name="contactHeading"
                                    className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                      formik.errors.contactHeading &&
                                      formik.touched.contactHeading &&
                                      "is-invalid"
                                    }`}
                                  />
                                  <div className="errorMsg fs-14 medium">
                                    {formik.touched.contactHeading && formik.errors.contactHeading}
                                  </div>
                                </div>
                              </div>
                              <div className="clear20"></div>
                              <div className="row">
                                <div className="col-lg-8 col-md-8">
                                  <label className="email black fs-18 emailtxtweb">
                                    SUB HEADING
                                  </label>
                                  <Field
                                    type="text"
                                    name="contactSubHeading"
                                    className={`form-control instn fs-16 regular w-100 olnone share-popup-input fmlabel ${
                                      formik.errors.contactSubHeading &&
                                      formik.touched.contactSubHeading &&
                                      "is-invalid"
                                    }`}
                                  />
                                  <div className="errorMsg fs-14 medium">
                                    {formik.touched.contactSubHeading &&
                                      formik.errors.contactSubHeading}
                                  </div>
                                </div>
                                </div>
                              <div className="clear20"></div>
                                <div className="row">
                                  <div className="mg-top-10">
                                    <button
                                      type="submit"
                                      className={formik.isValid ? "saveBtn1" : "saveBtn1 activv"}
                                      disabled={!formik.isValid}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </TabPanel>
                  </div>
                </div>
              </Tabs>
            </div>

            <SuccessDialog
              successPopUp={successPopup}
              toggleSuccessDialog={this.toggleSuccessDialog}
              msg={msg}
            />
            {submitting && <CircularProgress className="circle-mark" color="secondary" />}
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

export default WebsiteDetails;